import {ApolloClient, HttpLink, InMemoryCache} from '@apollo/client';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import {createErrorLink} from './auth_link.ts';

const baseUrl = '__EDLINK_BASE_URL__';

const httpCustomerLink = new HttpLink({
    uri: baseUrl + '/graphql/customer',
    headers: {
        Accept: 'application/json',
    },
});
const errorLink = createErrorLink();

export const customerClient = new ApolloClient({
    link: errorLink.concat(httpCustomerLink),
    cache: new InMemoryCache(),
});

export const pwaClient = new ApolloClient({
    uri: baseUrl + '/graphql/pwa',
    cache: new InMemoryCache(),
});

export const publicClient = new ApolloClient({
    uri: baseUrl + '/graphql/public',
    cache: new InMemoryCache(),
});

export const uploadingCustomerClient = new ApolloClient({
    uri: baseUrl + '/graphql/customer',
    cache: new InMemoryCache(),
    link: createUploadLink({uri: baseUrl + '/graphql/customer'}),
});
